import link from "@/scripts/host.js";

export default {
  name: 'from-archive',
  props: ['actualPlay', 'isPlaying'],
  data() {
    return{
      calendar: null,
      months: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca',
      'sierpnia', 'września', 'października', 'listopada', 'grudnia'],
      selectedDate: null
    }
  },
  methods: {
    playMP3(mp3) {
      this.$emit('songURL', mp3);
    }
  },
  computed: {
    calendarCard() {
      return this.calendar;
    },
    eventDate() {
      return this.selectedDate
    }
  },
  mounted(){
    this.axios.get(`${link.hostLink}Stats/GetCalendarPages`).then((response) => {
      let randomNumber = Math.floor(Math.random()*response.data.length) < 5 ? Math.floor(Math.random()*response.data.length) : 4;
      this.calendar = response.data[randomNumber];
      let today = new Date(this.calendarCard.date);
      this.selectedDate = "" + today.getDate() + " " + this.months[today.getMonth()] + " " + today.getFullYear();
    })
  }
}
